import CountryPageRenderer from '../components/CountryPageRenderer';
import costaRicaData from '../data/country-pages/costa-rica';

export default function CostaRicaCountryPage() {
  return <CountryPageRenderer data={costaRicaData} />;
}
